import { SET_RATINGS } from '../actions/types';

export default function ratings(state = {}, action) {
	if (!action.error && action.payload) {
		switch (action.type) {
			case SET_RATINGS:
				return action.payload;
			// no default
		}
	}

	return state;
}
